import React from 'react'
import { colors } from '../../../../styles/vars/colors.style'

const ExpeditionRoute4 = ({
  width = 200,
  height = 167,
  stroke = colors.dark,
  mask = colors.light,
  opacity = 1,
  pathLength = 324,
  responsive = true,
  forwardRef = null,
}) => {
  const svgAttributes = responsive
    ? {}
    : {
        width,
        height,
      }

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 200 167"
      focusable="false"
      role="img"
      fill="none"
      {...svgAttributes}
    >
      <path
        opacity={opacity}
        stroke={stroke}
        strokeWidth={1}
        strokeDasharray="2 3"
        d="M1 -49C109.626 -9.91954 185.664 22.6475 192.181 100.808C194.134 124.232 196.088 145.901 199.093 166.106"
      />
      <path
        opacity={opacity}
        stroke={mask}
        strokeWidth={2}
        ref={forwardRef.line}
        strokeDashoffset={0}
        strokeDasharray={pathLength}
        d="M1 -49C109.626 -9.91954 185.664 22.6475 192.181 100.808C194.134 124.232 196.088 145.901 199.093 166.106"
      />
    </svg>
  )
}

export default ExpeditionRoute4
